module.exports = __webpack_public_path__ + "img/cloud-intercom-welcome.b55937fc.webp";